import instObj from '@/backend/axios-instances'

const resource = "mitrex/estimations/items/elevations"
const instance = instObj.baseInstance

export default {
  get(parameters) {
    return instance.get(resource, { params: parameters });
  },
  post(data, parameters) {
    return instance.post(resource, data, { params: parameters });
  },
  updateOrders(data, parameters) {
    return instance.post(`${resource}/orders`, data, { params: parameters })
  }
}
